import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FRANCHISE_FLAGS } from '@shared/constants/franchise-flags';

@Component({
  selector: 'app-franchise-icon',
  imports: [],
  templateUrl: './franchise-icon.component.html',
  styleUrl: './franchise-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FranchiseIconComponent {
  franchiseRoute = input.required<string>();
  protected readonly FRANCHISE_FLAGS = FRANCHISE_FLAGS;
}
